import { ProjectState } from '../initState/InitState';

const reducer = (state: any = ProjectState, action: { type: string; payload: any }) => {
  console.debug(action.type, action.payload);
  switch (action.type) {
    case 'HEADER_LOADED':
      return { ...state, header: { ...state.header, ...action.payload } };
    case 'ALERT_LOADED':
      return { ...state, alert: action.payload };
    case 'STORIES_LOADED':
      return { ...state, stories: action.payload };
    case 'CALCULATOR_LOADED':
      return { ...state, calculator: action.payload };
    case 'ARTICLE_LOADED':
      return { ...state, article: action.payload };
    case 'VACANCIES_LOADED':
      return { ...state, vacancies: action.payload };
    case 'VACANCY_LOADED':
      return { ...state, vacancy: action.payload };
    case 'WIDTH_WINDOW_LOADED':
      return { ...state, widthWindow: action.payload };
    case 'OFFSET_CONTENT_LOADED':
      return { ...state, offsetContent: action.payload };
    case 'BLOG_LOADED':
      return { ...state, blog: action.payload };
    case 'BLOG_MAIN_LOADED':
      return { ...state, blogMain: action.payload };
    case 'BLOG_POPULAR_LOADED':
      return { ...state, blogPopular: action.payload };
    case 'LOGOS_PARTNERS_LOADED':
      return { ...state, logosPartners: action.payload };
    case 'ADVANTAGES_SLIDER_LOADED':
      return { ...state, advantagesSlider: action.payload?.slides, advantagesSliderTitle: action.payload?.title || '', advantagesSliderNoFade: action.payload?.no_fade || false };
    case 'REVIEWS_LOADED':
      return { ...state, reviews: action.payload };
    case 'ABOUT_LOADED':
      return { ...state, about: { ...state.about, ...action.payload } };
    case 'STATE_404_LOADED':
      return { ...state, state404: action.payload };
    case 'BLOCKED_SEND_LOADED':
      return { ...state, blockedSend: action.payload };
    case 'RECAPTCHAV2_LOADED':
      return { ...state, recaptchaV2ref: action.payload };
    case 'TEXT_CARDS_LOADED':
      return { ...state, textCards: action.payload };
    case 'ICON_CARDS_LOADED':
      return { ...state, iconCards: action.payload };
    case 'CONTACT_FORMS_LOADED':
      return { ...state, contactForms: action.payload };
    default:
      return state;
  }
};

export default reducer;
